import { Link } from "react-router-dom";

export default function AboutSection() {
  return (
    <section id="about" className="py-28 bg-[#050810] relative overflow-hidden">
      <div className="absolute top-1/2 left-0 w-80 h-80 rounded-full bg-[#d4af37]/5 blur-3xl -translate-y-1/2 pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Visual Side — icon/stat composition */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden bg-gradient-to-br from-[#0c0f1c] to-[#080b18] border border-white/5 p-10 min-h-[420px] flex flex-col justify-between">
              {/* Top row */}
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1 p-6 rounded-xl bg-[#d4af37]/8 border border-[#d4af37]/15">
                  <i className="ri-code-s-slash-line text-[#d4af37] text-3xl mb-3 block"></i>
                  <div className="text-white font-bold text-sm">Clean Code</div>
                  <div className="text-white/40 text-xs mt-1">Built to perform</div>
                </div>
                <div className="flex-1 p-6 rounded-xl bg-white/3 border border-white/8">
                  <i className="ri-palette-line text-white/60 text-3xl mb-3 block"></i>
                  <div className="text-white font-bold text-sm">Premium Design</div>
                  <div className="text-white/40 text-xs mt-1">No templates, ever</div>
                </div>
              </div>

              {/* Center stat */}
              <div className="text-center py-8">
                <div className="text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#d4af37] to-[#f0d060] mb-2">100%</div>
                <div className="text-white/50 text-sm tracking-wide">Committed to every project</div>
              </div>

              {/* Bottom row */}
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1 p-6 rounded-xl bg-white/3 border border-white/8">
                  <i className="ri-line-chart-line text-white/60 text-3xl mb-3 block"></i>
                  <div className="text-white font-bold text-sm">Results Driven</div>
                  <div className="text-white/40 text-xs mt-1">Measurable growth</div>
                </div>
                <div className="flex-1 p-6 rounded-xl bg-[#d4af37]/8 border border-[#d4af37]/15">
                  <i className="ri-user-star-line text-[#d4af37] text-3xl mb-3 block"></i>
                  <div className="text-white font-bold text-sm">Client First</div>
                  <div className="text-white/40 text-xs mt-1">Always in your corner</div>
                </div>
              </div>
            </div>

            {/* Floating badge */}
            <div className="absolute -top-4 -left-4 bg-[#d4af37] rounded-2xl p-4 hidden md:flex items-center gap-3">
              <i className="ri-shield-check-line text-[#050810] text-xl"></i>
              <div>
                <div className="text-[#050810] font-black text-sm">100% Custom</div>
                <div className="text-[#050810]/60 text-xs">No templates, ever</div>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div>
            <span className="text-[#d4af37] text-xs font-semibold tracking-widest uppercase mb-4 block">About Us</span>
            <h2 className="text-4xl md:text-5xl font-black text-white leading-tight mb-6">
              Built on Ambition,<br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d4af37] to-[#f0d060]">Driven by Results</span>
            </h2>

            <div className="space-y-5 text-white/60 text-base leading-relaxed">
              <p>
                GK Vertex Consulting was born from a simple belief: <strong className="text-white">every business deserves a website that actually works</strong>. Not just one that looks good — one that generates real leads, builds trust, and drives growth.
              </p>
              <p>
                We&apos;re a lean, driven agency that combines strategic thinking with premium design and technical excellence. We don&apos;t do cookie-cutter. We don&apos;t do templates. We build custom digital experiences that position our clients as the obvious choice in their market.
              </p>
              <p>
                As a growing agency, we&apos;re selective about who we work with — because we&apos;re fully committed to every project we take on. When you work with us, you get our best. Every time.
              </p>
            </div>

            <div className="grid grid-cols-2 gap-4 mt-10">
              {[
                { icon: "ri-heart-pulse-line", label: "Quality First" },
                { icon: "ri-bar-chart-grouped-line", label: "Results Driven" },
                { icon: "ri-lightbulb-flash-line", label: "Always Innovating" },
                { icon: "ri-user-star-line", label: "Client Focused" },
              ].map((val) => (
                <div key={val.label} className="flex items-center gap-3 p-4 rounded-xl border border-white/5 bg-[#0c0f1c]">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#d4af37]/10">
                    <i className={`${val.icon} text-[#d4af37] text-base`}></i>
                  </div>
                  <span className="text-white/70 text-sm font-medium">{val.label}</span>
                </div>
              ))}
            </div>

            <div className="mt-10">
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-[#d4af37]/30 text-[#d4af37] text-sm font-semibold hover:bg-[#d4af37]/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                Learn More About Us
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
